import type {
  AysCodeCodingSystem,
  AysCodingSystemClassification,
  AysCodingSystemSpecification,
} from '@bindoc-projects/code-domain-lib';
import type { AysCodeSpectrumMatching } from '@bindoc-projects/code-spectrum-domain-lib';
import type {
  FilterConditionDto,
} from './condition';
import {
  BdConditionEmptyArrayStrategy,
  BdContentCondition
} from './condition';

export class CodeSpectrumMigrationCondition<T> extends BdContentCondition<T> {
  constructor(
    id: string,
    public codeSpectrumIds?: string[],
    public codingSystem?: AysCodeCodingSystem,
    public matching?: AysCodeSpectrumMatching,
    public codeTypeSpecification?: AysCodingSystemSpecification,
    public codeTypeClassification?: AysCodingSystemClassification,
    public grouperVersionYear?: number,
    includes: T[] = [],
    excludes: T[] = [],
  ) {
    super(id, includes, excludes, BdConditionEmptyArrayStrategy.LEGACY);
  }

  override toJSON(): FilterConditionDto {
    const content = {
      includes: this._arrayToJson(this.includes, this._emptyArrayStrategy),
      excludes: this._arrayToJson(this.excludes, this._emptyArrayStrategy),
    };

    if (this.codeSpectrumIds) {
      content['codeSpectrumIds'] = this.codeSpectrumIds;
    }

    if (this.codingSystem) {
      content['codingSystem'] = this.codingSystem;
    }

    if (this.matching) {
      content['matching'] = this.matching;
    }

    if (this.codeTypeSpecification) {
      content['codeTypeSpecification'] = this.codeTypeSpecification;
    }

    if (this.codeTypeClassification) {
      content['codeTypeClassification'] = this.codeTypeClassification;
    }

    if (this.grouperVersionYear) {
      content['grouperVersionYear'] = this.grouperVersionYear;
    }

    return {
      [this.id]: content,
    };
  }
}
